var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-switch"},_vm._l((_vm.buttons),function(button){return _c('button',{key:button.title,class:[
      'modal-switch__button',
      { selected: _vm.activeGraphic === button.component } ],on:{"click":function($event){return _vm.setActiveGraphic(button.component)}}},[_vm._v(" "+_vm._s(button.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }